import Vue from 'vue';
import Headroom from 'headroom.js';

Vue.component('mobile-cta-bar', {
    mounted() {
        const myElement = document.querySelector('.mobile-cta-bar');
        const heroElement =
            document.querySelector('.page-header') ||
            document.querySelector('.teaser-model-hero__wrapper');
        const headroom = new Headroom(myElement, {
            offset: heroElement ? heroElement.offsetHeight : window.innerHeight,
        });
        headroom.init();
    },
});
